import {svgIconWrapper} from '../svg-icon-wrapper';

import JustcallRegular from './justcall-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <JustcallRegular {...props} />;
}

SvgComponent.iconName = 'justcallRegular';

export const JustcallRegularIcon = svgIconWrapper(SvgComponent);
